import axios, { AxiosInstance } from 'axios';
import { getApiUrl } from '../config/runtime';

let isLoggingOut = false;

const createApiClient = (): AxiosInstance => {
  const api = axios.create({
    baseURL: getApiUrl(),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  // Add token to requests
  api.interceptors.request.use((config) => {
    const token = localStorage.getItem('authToken');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  });

  // Handle response errors (e.g., expired tokens)
  api.interceptors.response.use(
    (response) => response,
    (error) => {
      // Check if the error is due to an expired or invalid token
      if (error.response && error.response.status === 401 && !isLoggingOut) {
        // Prevent multiple logout calls
        isLoggingOut = true;
        
        // Clear auth data
        localStorage.removeItem('authToken');
        localStorage.removeItem('user');
        
        // Redirect to login
        window.location.href = '/login';
      }
      
      return Promise.reject(error);
    }
  );

  return api;
};

export default createApiClient;
